module.exports = __webpack_public_path__ + "static/media/5-oditorski_doklad_20160622.62e25afe.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2016/5-oditorski_doklad_20160622.pdf
// module id = 168
// module chunks = 0